var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.92334C3.70727 0.92334 1.62811 2.17771 0.0938938 4.21515C-0.0312979 4.38207 -0.0312979 4.61527 0.0938938 4.78219C1.62811 6.82208 3.70727 8.07645 6 8.07645C8.29273 8.07645 10.3719 6.82208 11.9061 4.78465C12.0313 4.61772 12.0313 4.38452 11.9061 4.2176C10.3719 2.17771 8.29273 0.92334 6 0.92334ZM6.16447 7.01846C4.64253 7.1142 3.3857 5.85982 3.48144 4.33543C3.55999 3.0786 4.57871 2.05988 5.83553 1.98133C7.35747 1.8856 8.6143 3.13997 8.51856 4.66436C8.43756 5.91874 7.41884 6.93745 6.16447 7.01846ZM6.08837 5.85491C5.26849 5.90646 4.59098 5.23141 4.64498 4.41153C4.68671 3.73402 5.23658 3.18661 5.91408 3.14243C6.73397 3.09088 7.41148 3.76593 7.35747 4.58581C7.31329 5.26578 6.76342 5.81318 6.08837 5.85491Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1b88f7cc6333e6879ab95ce491f7efef.svg";
export { ForwardRef as ReactComponent };